import type { ReactNode } from "react";
import { RecyclingScene } from "../recycling-scene/index.ts";
import styles from "./start-page.module.css";

/**
 * The frame of a page with no project open: a kicker, a heading, and whatever follows, in a
 * column towards the left — the recycling loop behind it in the lower right corner, staying put
 * while the column scrolls.
 */
export function StartPage({
  title,
  children,
  after,
  wide,
}: {
  title: string;
  children: ReactNode;
  after?: ReactNode;
  /** Room for a grid across the page; the heading and lead keep their reading width. */
  wide?: boolean;
}) {
  return (
    <div className={styles.view}>
      {/* Clipped at the frame's edges, so the part that runs off them never makes it scroll. */}
      <div className={styles.backdrop} aria-hidden>
        <RecyclingScene className={styles.scene} />
      </div>
      <div className={styles.scroller}>
        <section className={styles.page} data-wide={wide}>
          <p className="sc-kicker">Sortera Lab</p>
          <h1 className={`sc-heading ${styles.title}`}>{title}</h1>
          {children}
        </section>
        {after}
      </div>
    </div>
  );
}

export function StartPageLead({ children }: { children: ReactNode }) {
  return <p className={styles.lead}>{children}</p>;
}

/** The page's buttons, as pills with the icon first. */
export function StartPageActions({ children }: { children: ReactNode }) {
  return <div className={styles.actions}>{children}</div>;
}

export function StartPageNote({ children }: { children: ReactNode }) {
  return <p className={styles.note}>{children}</p>;
}
